import { createSelector } from 'reselect';
import { reduxKey } from './constants';
import { PublicSessionState } from '@wix/da-react-context/pkg/publicSession';

function getSlice(state: any): PublicSessionState {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getSession = createSelector(getSlice, state => state);
